import { createContext } from 'react';

export interface PlanInterface {
  id: number;
  title: string;
  price: number;
  saving?: number;
  monthlyPrice?: number | string;
  duration: number;
  featured?: boolean;
  country: number;
}

export enum PaymentScreens {
  PLANS = 0,
  SIGNUP = 1,
  LOGIN = 2,
  CHECKOUT = 1,
}

export enum PlanIDs {
  NOTSET = 0,
  MONTHLY = 1,
  HALFMONTH = 2,
  YEARLY = 3,
}

export const PriceContext = createContext<Array<PlanInterface>>([]);
